var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Add circle icon",
    style: {
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 5,
    x2: 8,
    y2: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8,
    x2: 11,
    y2: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle16W);
export default __webpack_public_path__ + "static/media/Add_circle_16w.1bd865fcafd99704e5e081b1eb71fb01.svg";
export { ForwardRef as ReactComponent };